export const KILL_EVENT_PLAYER_ROLES = {
  Killer: CreateKillEventPlayerRole('Killer', 'Killer', 'Player who dealt the killing blow.'),
  Victim: CreateKillEventPlayerRole('Victim', 'Victim', 'Player who was killed.'),
  Assistant: CreateKillEventPlayerRole('Assistant', 'Assistant', 'Player who assisted in the kill (dmg or heal).'),
  GroupMember: CreateKillEventPlayerRole('GroupMember', 'Group Member', 'Player who was part of the group.'),
};

export interface KillEventPlayerRole {
  name: string;
  displayName: string;
  description: string;
}

export function CreateKillEventPlayerRole(name: string, displayName: string, description: string): KillEventPlayerRole {
  return { name, displayName, description };
}

export function GetAllKillEventPlayerRoles(): KillEventPlayerRole[] {
  return Object.values(KILL_EVENT_PLAYER_ROLES);
}